export class Pagination<T> {
    pageable: {
        sort: {
            sorted: boolean;
            unsorted: boolean;
        },
        pageSize: number;
        pageNumber: number;
        offset: number;
        unpaged: boolean;
        paged: boolean;
    };
    totalPages: number;
    totalElements: number;
    last: boolean;
    first: boolean;
    sort: {
        sorted: boolean;
        unsorted: boolean;
    };
    numberOfElements: number;
    size: number;
    number: number;
    content: Array<T> = [];
}
